import React, { useState, useEffect, useContext } from "react";
import { Container, Typography, Grid, Card, CardContent, Button, CircularProgress } from "@mui/material";
import { UserContext } from "../context/UserContext";

const ReferAFriend = () => {
  

  // Simulate API Call
 
  return (
    <Container maxWidth="lg" sx={{ mt: 5 }}>
      <Typography variant="h4" fontWeight="bold" textAlign="center"mb={3} sx={{color:"#42326e"}}>
       Refer A Friend
      </Typography>
      <Typography variant="h6" sx={{color:"black"}} fontWeight="bold" textAlign="center"mb={3}>
       By referring to a friend you can get upto 50% off !!!!!!!!!!!!!!!
      </Typography>

   
    </Container>
  );
};

export default ReferAFriend;
